// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"1fa560a7","634":"adf10374","782":"6192191e","892":"94f361cf","966":"0458b1cf","975":"d407453c"}[chunkId] + ".chunk.css";
};